<soft-master-detail
  *ngIf="settings"
  (selectedChange)="onSelect($event)"
  [data]="(settings$ | async) ?? []"
  [masterTemplate]="masterTemplate"
  [detailTemplate]="detailTemplate"
  class="flex flex-col flex-grow -mx-4"
>
</soft-master-detail>
<div class="flex flex-row items-center mt-5" *ngIf="!settings.length">
  {{ '#APPLICATION.SETTINGS.NO_SETTINGS' | translate }}
</div>
<ng-template #masterTemplate let-data="data">
  <div class="flex flex-row justify-between items-center flex-nowrap w-full py-2">
    <div class="flex flex-row items-center">
      <div class="icon mx-2">
        <i *ngIf="data.icon" [ngClass]="data.icon"></i>
      </div>
      {{ data.title | translate }}
    </div>
  </div>
</ng-template>
<ng-template #detailTemplate let-data="data">
  <div class="settings-page m-4">
    <ng-container *ngComponentOutlet="data.component"></ng-container>
  </div>
</ng-template>
